// extracted by mini-css-extract-plugin
module.exports = {"block":"navbar_block__c3Q8_","container":"navbar_container__mH5Pm","navLinkWrapper":"navbar_navLinkWrapper__soB0J"};